import React from 'react'
import { Helmet } from 'react-helmet'
import { useReactHelmetContext } from '../contextApi/ReactHelmetContext'
import { useRoomsContext } from '../contextApi/roomsContext'
import { SplashAndDine, SplashAndDineSlider} from '../components'

const SplashAndDinePage = () => {
  const {funImages} = useRoomsContext();
  const {fun } = useReactHelmetContext();

  return (
    <main>
      <Helmet>
        <title>{fun.title}</title>
        <meta name={fun.description} content={fun.content} />
        <meta  name={fun.keywords} keywords={fun.keywords}/>
      </Helmet>
      <SplashAndDineSlider data={funImages}/>
      <SplashAndDine/>
    </main>
  )
}

export default SplashAndDinePage